import { Component } from '@angular/core';

@Component({
  selector: 'app-attendance-report',
  templateUrl: './attendance-report.component.html',
})
export class AttendanceReportComponent {}
